import { BsDashLg } from "react-icons/bs";
import { formatPrice } from "../../../../../helper/formatPrice/format-price";

export default function ProductList(props) {
  const {
    productList,
    handleDeleteProduct,
    selectedProducts,
    handleSelectProduct,
    selectAll,
    handleChangeProductInsideTable,
    isReadOnlyMode = false,
  } = props;
  const header = [
    {
      title: (
        <input onChange={selectAll} type="checkbox" disabled={isReadOnlyMode} />
      ),
    },
    {
      title: "상품명",
    },
    {
      title: "REF(상품코드)",
    },
    {
      title: "색상코드",
    },
    {
      title: "원가",
    },
    {
      title: "정상 판매가",
    },
    {
      title: "할인율",
    },
    {
      title: "할인 판매가",
    },
    {
      title: "판매 상태",
    },
    {
      title: "신상품",
    },
    {
      title: "베스트",
    },
  ];

  return (
    <>
      <div className="mt-[15px] w-full block whitespace-nowrap overflow-auto">
        <table className="w-full text-center">
          <thead>
            <tr className="border border-[#dddddd]">
              <th
                colSpan={11}
                className="p-2 bg-[#f2f2f4] border border-[#dddddd]"
              >
                <div className="flex justify-between items-center">
                  <span>상품 리스트</span>
                  {!isReadOnlyMode && (
                    <button
                      onClick={(e) => handleDeleteProduct(e, selectedProducts)}
                      className={`bg-gradient-to-b from-white via-primary-white to-background-grey border border-button-grey  p-2 rounded-[4px] flex gap-2 items-center`}
                    >
                      <BsDashLg /> 선택삭제
                    </button>
                  )}
                </div>
              </th>
            </tr>
            <tr className="border border-[#dddddd]" key={0}>
              {header.map((val, index) => (
                <th
                  className="p-2 bg-[#f2f2f4] border border-[#dddddd]"
                  key={index}
                >
                  {val.title}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {productList?.map((data) => {
              return (
                <tr key={data?.ref}>
                  <td className="p-2 border border-[#dddddd]">
                    <input
                      type="checkbox"
                      onChange={() => handleSelectProduct(data?.ref)}
                      checked={selectedProducts?.includes(data?.ref)}
                      disabled={isReadOnlyMode}
                    />
                  </td>
                  <td className="p-2 border border-[#dddddd]">
                    {data?.width && data?.length
                      ? `${data?.name} ${data?.width} x ${data?.length}mm`
                      : data?.name}
                  </td>
                  <td className="p-2 border border-[#dddddd]">{data?.ref}</td>
                  <td className="p-2 border border-[#dddddd]">
                    <div className="py-1 bg-[#eeeeee] border px-2.5 text-left border-[#cccccc] rounded-[4px] h-8">
                      {data?.color?.toUpperCase()}
                    </div>
                  </td>
                  <td className="p-2 border border-[#dddddd]">
                    <input
                      type="text"
                      className="py-1 px-2.5 border border-[#cccccc] rounded-[4px] w-[80px] h-8"
                      onChange={(e) =>
                        handleChangeProductInsideTable(
                          e,
                          "costPrice",
                          data?.ref
                        )
                      }
                      defaultValue={formatPrice(data?.costPrice) ?? ""}
                      disabled={isReadOnlyMode}
                    />
                  </td>
                  <td className="p-2 border border-[#dddddd]">
                    <input
                      type="text"
                      className="py-1 px-2.5 border border-[#cccccc] rounded-[4px] w-[80px] h-8"
                      onChange={(e) =>
                        handleChangeProductInsideTable(e, "oriPrice", data?.ref)
                      }
                      defaultValue={formatPrice(data?.oriPrice) ?? ""}
                      disabled={isReadOnlyMode}
                    />
                  </td>
                  <td className="p-2 border border-[#dddddd]">
                    <div className="flex justify-center">
                      <input
                        type="number"
                        className="p-1 border border-[#cccccc] border-r-0 rounded-l-[2px] w-12 h-8 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                        onChange={(e) =>
                          handleChangeProductInsideTable(
                            e,
                            "discountRate",
                            data?.ref
                          )
                        }
                        defaultValue={(data?.discountRate).toFixed(1) ?? ""}
                        disabled={isReadOnlyMode}
                      />
                      <div className="p-1 rounded-r-[2px] flex items-center justify-center border border-[#cccccc] w-8 h-8">
                        %
                      </div>
                    </div>
                  </td>
                  <td className="p-2 border border-[#dddddd]">
                    <div className="py-1 px-2.5 text-left bg-[#eeeeee] border border-[#cccccc] rounded-[4px] h-8">
                      {formatPrice(data?.price.toFixed(0))}
                    </div>
                  </td>
                  <td className="p-2 border border-[#dddddd]">
                    {data?.saleStatus === "SALE" ? "정상" : "판매종료"}
                  </td>
                  <td className="p-2 border border-[#dddddd]">
                    <div className="flex -mx-4 justify-center">
                      <input
                        type="checkbox"
                        onChange={(e) =>
                          handleChangeProductInsideTable(e, "isNew", data?.ref)
                        }
                        checked={Boolean(data?.isNew)}
                        disabled={isReadOnlyMode}
                      />
                    </div>
                  </td>
                  <td className="p-2 border border-[#dddddd]">
                    <div className="flex -mx-4 justify-center">
                      <input
                        type="checkbox"
                        onChange={(e) =>
                          handleChangeProductInsideTable(e, "isBest", data?.ref)
                        }
                        checked={Boolean(data?.isBest)}
                        disabled={isReadOnlyMode}
                      />
                      <input
                        type="number"
                        className="ml-2 py-1 px-2.5 border border-r-0 border-[#cccccc] rounded-l-[2px] w-16 h-8 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                        onChange={(e) =>
                          handleChangeProductInsideTable(
                            e,
                            "bestRank",
                            data?.ref
                          )
                        }
                        value={data?.bestRank ?? ""}
                        disabled={isReadOnlyMode}
                      />
                      <div className="p-1 flex items-center justify-center rounded-r-[2px] border w-8 border-[#cccccc] h-8">
                        순위
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}
